import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const LINKS = [
  { label: "Packages", href: "#packages" },
  { label: "Sprint", href: "#sprint" },
  { label: "Process", href: "#process" },
  { label: "Why Us", href: "#why-us" },
  { label: "FAQs", href: "#faqs" },
];

export const Header = ({ onAudit }) => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 backdrop-blur-xl bg-[#0b1426]/85 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" data-testid="header-logo-link" className="flex items-center">
          <img src="/assets/webastra-header-lockup.webp" alt="Webastra — Out of the World" className="h-10 sm:h-12 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              href={l.href}
              className="text-sm font-medium text-slate-300 hover:text-[#fba31b] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-book-audit-btn"
            onClick={onAudit}
            className="hidden sm:inline-flex items-center gap-2 bg-[#fba31b] hover:bg-[#e59312] text-[#12203c] text-sm font-bold px-5 py-2.5 rounded-full transition-colors hover:shadow-[0_0_30px_rgba(251,163,27,0.45)]"
          >
            Book a Free Audit <ArrowRight className="w-4 h-4" />
          </button>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-white/5 bg-[#0b1426] px-4 py-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-slate-200 font-medium border-b border-white/5 last:border-0"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="mobile-book-audit-btn"
            onClick={() => { setOpen(false); onAudit(); }}
            className="mt-3 w-full bg-[#fba31b] text-[#12203c] font-bold px-5 py-3 rounded-full"
          >
            Book a Free Audit
          </button>
        </div>
      )}
    </header>
  );
};
